import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ExternalLink, Loader2, Settings2 } from "lucide-react";
import api from "../../../lib/api";
import { COMPLIANCE, LEGAL } from "../../../lib/saisonnier";

const Gauge = ({ n }) => {
  const color = n.pct >= 100 ? "bg-red-500" : n.pct >= 90 ? "bg-orange-500" : n.pct >= 80 ? "bg-amber-400" : "bg-emerald-500";
  return (
    <div data-testid="nights-gauge">
      <div className="flex justify-between text-xs text-brand-green/60 mb-1"><span>Nuitées {n.year} (résidence principale)</span><span className="font-semibold text-brand-greenDeep">{n.projected} / {n.plafond}</span></div>
      <div className="h-2.5 rounded-full bg-brand-softer overflow-hidden"><div className={`h-full ${color} transition-all`} style={{ width: `${Math.min(100, n.pct)}%` }} /></div>
      <p className="text-[11px] text-brand-green/45 mt-1">{n.realised} nuits réalisées · projection incluant les réservations à venir. Blocage des nouvelles réservations à 100 %.</p>
    </div>
  );
};

export default function SaisonnierConformite() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/str/compliance").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="py-20 text-center"><Loader2 className="w-6 h-6 animate-spin mx-auto text-brand-green/40" /></div>;
  return (
    <div className="space-y-5 max-w-4xl" data-testid="str-compliance">
      <div>
        <h1 className="font-display text-3xl font-semibold text-brand-greenDeep">Conformité</h1>
        <p className="text-sm text-brand-green/55">Obligations françaises de chaque meublé de tourisme. <a href={d.teleservice_url} target="_blank" rel="noreferrer" className="underline inline-flex items-center gap-0.5">Téléservice d'enregistrement <ExternalLink className="w-3 h-3" /></a></p>
      </div>
      {d.properties.length === 0 && <p className="text-sm text-brand-green/55">Aucun bien saisonnier.</p>}
      {d.properties.map((p) => (
        <div key={p.property_id} className="bg-white rounded-2xl border border-brand-soft p-5 space-y-4" data-testid={`compliance-${p.property_id}`}>
          <div className="flex items-center gap-3">
            <p className="font-semibold text-brand-greenDeep flex-1">{p.name} {p.statut !== "actif" && <span className="ml-2 text-[10px] px-2 py-0.5 rounded-full bg-amber-100 text-amber-800">Brouillon</span>}</p>
            <span className={`text-sm font-bold px-3 py-1 rounded-full ${p.score === p.total ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-800"}`} data-testid={`compliance-score-${p.property_id}`}>{p.score}/{p.total}</span>
            <button onClick={() => navigate(`/app/saisonnier/biens/${p.property_id}`)} className="p-2 rounded-full hover:bg-brand-softer" data-testid={`compliance-edit-${p.property_id}`}><Settings2 className="w-4 h-4" /></button>
          </div>
          {p.nights && <Gauge n={p.nights} />}
          <div className="divide-y divide-brand-soft">
            {p.items.map((it) => (
              <div key={it.key} className="flex items-center gap-3 py-2.5" data-testid={`compliance-item-${p.property_id}-${it.key}`}>
                <span className={`w-2.5 h-2.5 rounded-full ${COMPLIANCE[it.status].dot}`} />
                <div className="flex-1"><p className="text-sm font-medium text-brand-greenDeep">{it.label}</p><p className="text-xs text-brand-green/55">{it.detail}</p></div>
                {it.due && <span className="text-xs text-brand-green/50">Échéance {new Date(it.due).toLocaleDateString("fr-FR")}</span>}
                <span className={`text-[11px] px-2 py-0.5 rounded-full font-semibold ${COMPLIANCE[it.status].cls}`}>{COMPLIANCE[it.status].label}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
      <p className="text-[11px] text-brand-green/45">{LEGAL}</p>
    </div>
  );
}
